import { render, staticRenderFns } from "./SinglePostComponent.vue?vue&type=template&id=8d7f9678&"
import script from "./SinglePostComponent.vue?vue&type=script&lang=js&"
export * from "./SinglePostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/niclas.sauffaus/Dev/audible/wp-content/themes/audible/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d7f9678')) {
      api.createRecord('8d7f9678', component.options)
    } else {
      api.reload('8d7f9678', component.options)
    }
    module.hot.accept("./SinglePostComponent.vue?vue&type=template&id=8d7f9678&", function () {
      api.rerender('8d7f9678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/SinglePostComponent.vue"
export default component.exports